export default "__VITE_ASSET__C_b11V6v__"